const modulo = 'rutas-enlaces'
module.exports = {
    modulo
}